import axios from 'axios'
import { getUserToken } from '@/services/auth'

const TIMEOUT = 1000000

export const HTTP_HYPER_ESPACE_BACKEND = axios.create({
  baseURL: processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const HTTP_UBIFLOW_API = axios.create({
  baseURL: processEnvConfig.VUE_APP_UBIFLOW_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const HTTP_AUTH = axios.create({
  baseURL: processEnvConfig.VUE_APP_PASSE_PARTOUT_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const HTTP_LOGS = axios.create({
  baseURL: processEnvConfig.VUE_APP_UBIFLOW_API_LOGS_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

const requestAuthorizationInterceptor = (config) => {
  const userToken = getUserToken()
  if (userToken) {
    if (!config.headers) {
      config.headers = {}
    }
    config.headers.Authorization = 'Bearer ' + userToken
  }

  config.timeout = TIMEOUT
  return config
}
const requestXAuthTokenInterceptor = (config) => {
  const userToken = getUserToken()
  if (userToken) {
    if (!config.headers) {
      config.headers = {}
    }
    config.headers["X-AUTH-TOKEN"] = 'Bearer ' + userToken
  }

  config.timeout = TIMEOUT
  return config
}

export const setupAxios = () => {
  if (HTTP_HYPER_ESPACE_BACKEND.interceptors) {
    HTTP_HYPER_ESPACE_BACKEND.interceptors.request.use(requestAuthorizationInterceptor)
  }
  if (HTTP_UBIFLOW_API.interceptors) {
    HTTP_UBIFLOW_API.interceptors.request.use(requestAuthorizationInterceptor)
  }
  if (HTTP_LOGS.interceptors) {
    HTTP_LOGS.interceptors.request.use(requestXAuthTokenInterceptor)
  }
}
